import { createContext } from 'use-context-selector'

export const MonitorContext = createContext()
